module.exports = __webpack_public_path__ + "static/img/19.43370b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u_img/19.png
// module id = cs+3
// module chunks = 2